import { MultiSelect, SingleSelect } from '@dangnhz/custom-select';
import '@dangnhz/custom-select/styles.css';
import keyboardFocus from 'keyboard-focus';

keyboardFocus(document);

function addingAsterisk() {
  const requiredLabels = document.querySelectorAll('.js-form-type-checkbox label.js-form-required, .js-form-type-radio label.js-form-required');
  if (!requiredLabels.length > 0) return;
  requiredLabels.forEach((item) => {
    if (item.querySelector('span.asterisk')) return;
    const asterisk = document.createElement('span');
    asterisk.innerText = '*';
    asterisk.classList.add('asterisk');
    item.appendChild(asterisk);
  });
}

function initSingleSelects() {
  const instances = SingleSelect.init('select:not([multiple])', {
    placeholder: 'Select',
    searchEnabled: false,
    showClear: false,
    showClose: false,
    clearText: 'Clear ✕',
    position: 'bottom',
    returnFocusOnClose: true,
    closeOnSelect: true,
    maxHeight: 350,
  });
}

function initMultiSelects() {
  const selects = document.querySelectorAll('select[multiple]');

  if (!selects.length) return;

  selects.forEach((select) => {
    const label = select.closest('.form-item')?.querySelector('label')?.textContent?.trim() || 'Select';

    new MultiSelect(select, {
      searchEnabled: false,
      showClearAll: false,
      showClose: false,
      returnFocusOnClose: true,
      clearAllText: 'Clear all ✕',
      selectedDisplayMode: 'custom',
      position: 'bottom',
      selectedFormat: (options) => {
        if (options.length === 0) return label;
        if (options.length === 1) return options[0].label;
        return `${options.length} selections`;
      },
    });
  });
}

window.addEventListener('load', () => {
  addingAsterisk();
  initMultiSelects();
  initSingleSelects();
});
